import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { OrigemPipeModule } from '../../../../common/origens/pipes';
import { TemperaturaPipeModule } from '../../../../common/temperatura/pipes';
import { LeadTableComponent } from './lead-table.component';

@NgModule({
    imports: [
        SharedModule,
        OrigemPipeModule,
        TemperaturaPipeModule
    ],
    declarations: [
        LeadTableComponent
    ],
    exports: [
        LeadTableComponent
    ]
})
export class LeadTableModule { }
